/* eslint-disable quote-props */
import axios from 'axios'

const create = () => {
  const baseURL = 'https://api.7glyphs.com'
  const api = axios.create({
    baseURL,
    headers: {
      'Accept': 'application/json'
    }
  })
  const formHeaders = { headers: { 'Content-Type': 'multipart/form-data', 'Content-Disposition': 'form-data' } }
  const submitJoinUsForm = inputData => api.post('api/mail/join-us', inputData, formHeaders)
  const submitBriefForm = inputData => api.post('api/mail/brief', inputData, formHeaders)

  return {
    submitJoinUsForm,
    submitBriefForm
  }
}

export default {
  create
}
